<div style="padding: 35px 20px 40px;">
  <nz-steps
    [nzCurrent]="currentIndex"
    [nzLabelPlacement]="'vertical'"
    class="charts-steps-container"
  >
    <nz-step nzTitle="Type"></nz-step>
    <nz-step nzTitle="Companies" class="step-2-title"> </nz-step>
    <nz-step nzTitle="Line Items" class="step-3-title"></nz-step>
    <nz-step nzTitle="Periods"></nz-step>
  </nz-steps>
</div>

<div
  [ngSwitch]="currentIndex"
  [ngClass]="{
    'step-1-content': currentIndex === 0,
    'step-2-content': currentIndex === 1,
    'step-3-content': currentIndex === 2
  }"
>
  <app-create-new-charts-base
    *ngSwitchCase="0"
    (setContext)="setContext($event)"
  >
  </app-create-new-charts-base>
  <div *ngSwitchCase="1">
    <!-- <app-charts-ticker-modal
          [modalVisible]="true"
            [addRowTableData]="addRowTableData"
            [watchlists]="watchlists"
            [recentlyVisitedCompanies]="recentlyVisitedCompanies"
            maxHeight="250px"
            [mpt]="mpt"
            type="create"
            (tickerUpdate)="onTickerUpdate($event)"
            (mptUpdate)="onMptUpdate($event)"
          >
          </app-charts-ticker-modal> -->
    <app-edit-charts-ticker
      [addRowTableData]="addRowTableData"
      [(watchlists)]="watchlists"
      [recentlyVisitedCompanies]="recentlyVisitedCompanies"
      [peerCompanies]="[]"
      [mpt]="mpt"
      [max]="10"
      type="create"
      [maxHeight]="'327px'"
      (mptUpdate)="onMptUpdate($event)"
      (onChangeTickers)="tickerUpdate($event)"
      (mptUpdate)="onMptUpdate($event)"
    ></app-edit-charts-ticker>
  </div>
  <div *ngSwitchCase="2">
    <app-edit-charts-li
      [addColTableData]="addColTableData"
      [stdLineItems]="stdLineItems"
      [max]="2"
      maxHeight="310px"
      [tickers]="tickers"
      lineItemInputId="chartsEditModalLineItemInput"
      (onLiUpdate)="onUpdateChart($event)"
    ></app-edit-charts-li>
  </div>
  <div *ngSwitchCase="3">
    <app-create-new-charts-naming
      [companyData]="addRowTableData"
      [liData]="addColTableData"
      [type]="context"
      [revision]="revision"
      [createPeriod]="createPeriod"
      [filterData]="filterData"
      [yearTypeData]="yearTypeData"
      (saveChartsName)="updateChartName($event)"
      (saveEstimate)="updateEstimate($event)"
      (saveRevision)="updateRevision($event)"
      (saveYearType)="updateYearType($event)"
    ></app-create-new-charts-naming>
  </div>
</div>
